import * as angular from 'angular';
import * as ngCookies from 'angular-cookies';
import { FullstoryProvider } from './fullstory.service';

export const fullstoryModule = angular.module('FullstoryModule', [
	ngCookies
])
	.provider(FullstoryProvider.NG1_INJECTION_NAME, FullstoryProvider)
	.name;
